import { render, staticRenderFns } from "./questionnaireAnswer.vue?vue&type=template&id=3ddbcc20&scoped=true&"
import script from "./questionnaireAnswer.vue?vue&type=script&lang=js&"
export * from "./questionnaireAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddbcc20",
  null
  
)

export default component.exports